import React from 'react'
import { Popup } from '../Popup'

function VideoPopup({videoLink, setVideoLink}) {
  return (
    <Popup show={videoLink} close={() => setVideoLink('')} className={'wbp_video'}>
      <div
        style={{
          width: '80vw',
          height: '80vh',
          margin: 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            position: 'absolute',
            color: '#464646',
            fontSize: '100px',
            top: '0',
            right: '0',
            zIndex: '2',
            cursor: 'pointer',
            lineHeight: '44px',
            margin: '40px',
          }}
          onClick={() => setVideoLink('')}
          onKeyDown={() => setVideoLink('')}
          tabIndex="0"
          role="button"
        >
          ˟
        </div>
        {!videoLink.includes('cloudfront') && !videoLink.includes('radioly') && (
          <iframe
            style={{
              height: '100%',
              width: '100%',
            }}
            src={`https://www.youtube.com/embed/${videoLink}?autoplay=1`}
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen="true"
          ></iframe>
        )}
        {(videoLink.includes('cloudfront') ||
          videoLink.includes('radioly')) && (
          <video
            controls
            autoPlay
            preload="metadata"
            // onPlay={() => sendVideoPlayedEvent()}
            // onTimeUpdate={handleTimeUpdate}
            style={{
              maxWidth: '-webkit-fill-available',
              maxHeight: '-webkit-fill-available',
            }}
          >
            <source src={videoLink} type="video/mp4" />
          </video>
        )}
      </div>
    </Popup>
  )
}

export default VideoPopup
